import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '../ui/Button.js';

export function SwUpdateBanner(): React.ReactElement | null {
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisterError(err) {
      console.error('SW registration error:', err);
    },
  });
  const [need] = needRefresh;
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (need) setReloading(false);
  }, [need]);

  if (!need) return null;

  // `.bandeau` du kit, ramené dans le flux (`static`) et sans l'encoche (`pt-1`) : il se place
  // SOUS la barre de l'écran, qui absorbe déjà l'encoche, et part avec le défilement — collé en
  // haut, il recouvrait la barre et ses boutons jusqu'au rechargement.
  return (
    <div className="bandeau static pt-1 justify-between" role="status">
      <span>New version available</span>
      <Button
        size="small"
        loading={reloading}
        onClick={() => {
          setReloading(true);
          void updateServiceWorker(true);
        }}
      >
        Reload
      </Button>
    </div>
  );
}
